// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list___QWAY","item":"List_item__S4x7p"};